
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const ReportsSettings = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Reports Settings</CardTitle>
        <CardDescription>
          Configure your report preferences
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p>Reports settings content will be implemented here.</p>
      </CardContent>
    </Card>
  );
};
